var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cards"}},[_c('module-title',{attrs:{"title":"今日类别销售 TOP15"}}),_c('el-carousel',{staticStyle:{"width":"100%","height":"100%"},attrs:{"direction":"vertical","autoplay":true,"indicator-position":"none"}},[_c('el-carousel-item',[_c('div',{staticStyle:{"width":"26vw","height":"28vh"},attrs:{"id":"topChart"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }